export default __webpack_public_path__ + "static/placeholder-logo-bd4a7035490e7d1e3580f3a2bee4e39f.svg";